<div class="news-list">
  <app-news-card
    *ngFor="let newsItem of news | async"
    [newsItem]="newsItem"
  ></app-news-card>
</div>
